const RIGID_HAUL_TRUCK = {
  length: 8.6,
  bodyWidth: 2.86,
  wheelRadius: 0.8,
  tyreWidth: 0.48,
  dualSpacing: 0.38,
  axles: [
    { fitment: 'single', x: 2.55, halfTrack: 1.12 },
    { fitment: 'dual', x: -2.05, halfTrack: 0.98 },
  ],
  chassisY: 1.35,
};

export { RIGID_HAUL_TRUCK };
